module.exports = __webpack_public_path__ + "assets/img/0812.a1864ddf.svg";